import { render, staticRenderFns } from "./charmList.vue?vue&type=template&id=3db1a704&scoped=true&"
import script from "./charmList.vue?vue&type=script&lang=js&"
export * from "./charmList.vue?vue&type=script&lang=js&"
import style0 from "./charmList.vue?vue&type=style&index=0&id=3db1a704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db1a704",
  null
  
)

export default component.exports